import { useEffect, useMemo, useState, type CSSProperties } from 'react'
import type { Book } from '../types'

const localCovers: Record<string, string> = {
  'dom-casmurro': '/covers/dom-casmurro.svg',
  'memorias-postumas': '/covers/memorias-postumas.svg',
  iracema: '/covers/iracema.svg',
  'o-cortico': '/covers/o-cortico.svg',
  helena: '/covers/helena.svg',
  'policarpo-quaresma': '/covers/policarpo-quaresma.svg',
  'quincas-borba': '/covers/quincas-borba.svg',
  senhora: '/covers/senhora.svg',
  'a-moreninha': '/covers/a-moreninha.svg',
  '1984': '/covers/1984.svg',
  pride: '/covers/pride.svg',
  hobbit: '/covers/hobbit.svg',
  dune: '/covers/dune.svg',
  'tide-city': '/covers/tide-city.svg'
}

export function localCoverFor(bookId: string) {
  return localCovers[bookId]
}

export function BookCover({ book, className = '', eager = false }: { book: Book; className?: string; eager?: boolean }) {
  const fallback = useMemo(() => localCovers[book.id], [book.id])
  const [source, setSource] = useState(book.coverUrl || fallback || '')
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    setSource(book.coverUrl || fallback || '')
    setFailed(false)
  }, [book.coverUrl, book.id, fallback])

  if (!source || failed) {
    return (
      <div
        className={`generated-cover ${className}`}
        style={{ '--cover-accent': book.accent || '#7354ef' } as CSSProperties}
        role="img"
        aria-label={`Capa ilustrativa de ${book.title}`}
      >
        <span>LIVROOM</span>
        <strong>{book.title}</strong>
        <small>{book.author}</small>
      </div>
    )
  }

  return (
    <img
      className={className}
      src={source}
      alt={`Capa de ${book.title}`}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      onError={() => {
        if (fallback && source !== fallback) setSource(fallback)
        else setFailed(true)
      }}
    />
  )
}
